export const telegramProfileRegExp = new RegExp('^https:\\/\\/t\\.me\\/([A-Za-z0-9_]{5,})$');

export const instagramProfileRegExp = new RegExp(
    '^https://www\\.instagram\\.com/([A-Za-z0-9_.]+)$',
);

export const publicIdRegExp = new RegExp('^@.+$');

export const excludeCyrillicRegExp = new RegExp('^[^а-яА-Я]+$');

export const excludeSymbolsRegExp = new RegExp('^[^;<>/]+$');

export const instagramLinkRegExp = new RegExp('^.*(instagram\\.com).*$');

export const vkLinkRegExp = new RegExp('^.*(vk\\.com).*$');

export const facebookLinkRegExp = new RegExp('^.*(facebook\\.com).*$');

export const youtubeLinkRegExp = new RegExp('^.*(youtube\\.com).*$');

export const youtuLinkRegExp = new RegExp('^.*(youtu\\.be).*$');

export const tBotDetection = new RegExp('^.*(TelegramBot).*$');
